import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import BackupIcon from '@material-ui/icons/Backup';
import Grid from '@material-ui/core/Grid';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloseIcon from '@material-ui/icons/Close';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import LinkIcon from '@material-ui/icons/Link';
import Modal from '@material-ui/core/Modal';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment';
import DropZone from '../../components/DropZone';
import 'moment/locale/pt-br';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import HeadTable from '../../components/HeadTable';

const useStyles = makeStyles({
  root: {
    width: '100%',
    paddingTop: '1%',
  },
  loading: {
    marginLeft: '50%',
  },
});

function Importacao() {
  const classes = useStyles();
  const [importacoes, setImportacoes] = useState([]);
  const [modalAddFile, setModalAddFile] = useState(false);
  const [alert, setAlert] = useState(false);
  const [tipoAlerta, setTipoAlerta] = useState('');
  const [mensagemAlerta, setMensagemAlerta] = useState('');
  const [ready, setReady] = useState(false);
  const [page, setPage] = React.useState(0);
  const [columns, setcolumns] = useState([
    { id: 'id', label: '#', minWidth: 60 },
    { id: 'nome', label: 'Nome', minWidth: 180 },
    { id: 'created_at', label: 'Data Importação', minWidth: 140 },
    { id: 'status', label: 'Status', minWidth: 80 },
    { id: 'caminho', label: 'Arquivo', minWidth: 60 },
  ]);
  const [count, SetCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [campoOrdenacao, setCampoOrdenacao] = useState('');
  const [ordem, setOrdem] = useState('');

  const atualizarImportacoes = async (limit, offset, cmpOrdem, ord) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(
        `${environment}/importacaoPlanilha?limit=${limit}&offset=${offset}&campoOrdenacao=${cmpOrdem}&ordem=${ord}`
      )
      .then((res) => {
        setImportacoes(res.data.rows);
        SetCount(res.data.count);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setTipoAlerta('warning');
        setMensagemAlerta(
          'Houve um erro de comunicação, verifique sua conexão e tente novamente mais tarde.'
        );
        setAlert(true);
        setImportacoes([]);
        SetCount(0);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    atualizarImportacoes(rowsPerPage, newPage, campoOrdenacao, ordem);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    atualizarImportacoes(event.target.value, 0, campoOrdenacao, ordem);
  };

  const handleError = () => {
    console.log('qasdasdasd');
  };

  const handleAddFile = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalAddFile}
        onClose={() => setModalAddFile(false)}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: 5,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <DropZone
            handleButtonClick={async (file) => {
              setModalAddFile(false);
              if (file) {
                const nome = file[0].name.split('.');

                const formData = new FormData();
                formData.append('file', file[0]);
                formData.append('nome', nome[0]);

                await instanceAxios(localStorage.getItem('toobiauth'))
                  .post('/importacaoPlanilha', formData)
                  .then((res) => {
                    console.log(res.data);
                    setImportacoes([...importacoes, res.data.importacao]);
                    setTipoAlerta('success');
                    setMensagemAlerta('Upload realizado com sucesso.');
                    setAlert(true);
                  })
                  .catch((err) => {
                    setAlert(true);
                    setTipoAlerta('warning');
                    setMensagemAlerta(
                      'Houve um erro de comunicação, verifique sua conexão e tente novamente mais tarde.'
                    );
                  });
              }
            }}
          />
        </div>
      </Modal>
    );
  };

  const getStatus = (status) => {
    if (status === 1) {
      return <Chip label="Enviada" />;
    }
    if (status === 2) {
      return <Chip label="Processando" style={{ backgroundColor: 'yellow' }} />;
    }
    if (status === 3) {
      return (
        <Chip
          label="Lançada"
          color="primary"
          style={{ backgroundColor: '#32CD32' }}
        />
      );
    }
    if (status === 4) {
      return (
        <Chip
          label="Erro ao processar"
          style={{ backgroundColor: 'red' }}
          onClick={handleError}
        />
      );
    }
  };

  const handleCampoOrdenacao = (co) => {
    if (co === 'caminho') return;

    let o;
    // Checando se é o mesmo atual
    if (co === campoOrdenacao) {
      o = ordem === 'asc' ? 'desc' : 'asc';
      setOrdem(o);
    } else {
      o = 'asc';
      setOrdem(o);
      setCampoOrdenacao(co);
    }

    atualizarImportacoes(rowsPerPage, page, co, o);
  };

  useEffect(() => {
    atualizarImportacoes(5, 0, '', '');
  }, []);

  return (
    <div style={{ margin: 20 }}>
      <h1 style={{ textAlign: 'center' }}>Importações</h1>
      <Collapse in={alert}>
        <Alert
          variant="filled"
          severity={tipoAlerta}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setAlert(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {mensagemAlerta}
        </Alert>
      </Collapse>
      <Paper className={classes.root}>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              startIcon={<BackupIcon />}
              onClick={() => setModalAddFile(true)}
            >
              Realizar Upload
            </Button>
            <Button
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              startIcon={<CloudDownloadIcon />}
              href="http://portal.xmeibrasil.com.br/storage/planilhas/Planilha_XMEI.xlsx"
            >
              Baixar Modelo
            </Button>
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <HeadTable
                order={ordem}
                idOrder={campoOrdenacao}
                columns={columns}
                setIdOrder={handleCampoOrdenacao}
              />
            </TableHead>
            <TableBody>
              {importacoes.map((i) => {
                return (
                  <TableRow key={i.id}>
                    <TableCell component="th" scope="row">
                      {i.id}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {i.nome}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {moment(i.createdAt).format('L')}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {getStatus(i.status)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        color="primary"
                        aria-label="Baixar Arquivo"
                        href={i.caminho}
                      >
                        <LinkIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
        {handleAddFile()}
      </Paper>
    </div>
  );
}

export default Importacao;
